import React, { FC } from 'react'
import {
  BannerImg,
  OpenButton,
  Page,
  SubTitle,
  Title,
} from './LandingPageMobile.styles'
import { HeaderMobile } from '../../components/Header/HeaderMobile'
import BannerImageMobile from '../../assets/banner-image-mobile.png'

export const LandingPageMobile: FC = () => (
  <Page>
    <HeaderMobile />

    <Title>
      Banking, Simplified. Onboard in <br />
      <span>3 minutes</span>.
    </Title>

    <SubTitle>
      Zero Fees. Total Freedom. <br /> Your Money, Your Rules - No Fees, No
      Hassle
    </SubTitle>

    <OpenButton href="/steps">
      Open an account
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M16.1995 8.17548C15.8822 7.85817 15.3678 7.85817 15.0505 8.17548C14.7332 8.49278 14.7332 9.00722 15.0505 9.32452L19.9134 14.1875L8.125 14.1875C7.67627 14.1875 7.3125 14.5513 7.3125 15C7.3125 15.4487 7.67627 15.8125 8.125 15.8125L19.9135 15.8125L15.0505 20.6755C14.7332 20.9928 14.7332 21.5072 15.0505 21.8245C15.3678 22.1418 15.8822 22.1418 16.1995 21.8245L22.4495 15.5745C22.7668 15.2572 22.7668 14.7428 22.4495 14.4255L16.1995 8.17548Z"
          fill="white"
        />
      </svg>
    </OpenButton>

    <BannerImg>
      <img src={BannerImageMobile} alt="banner img" />
    </BannerImg>
  </Page>
)
